
import Button from '../../../components/base/Button';

export default function MembershipTypesSection() {
  const membershipPlans = [
    {
      title: "Pharmacist Professional",
      price: "$199",
      period: "per year",
      description: "Comprehensive membership for licensed pharmacists seeking professional development and networking opportunities.",
      icon: "ri-medicine-bottle-line",
      color: "blue",
      popular: true,
      features: [
        "Access to all continuing education programs",
        "Professional development workshops",
        "Networking events and conferences",
        "Research database access",
        "Legal and regulatory updates",
        "Career advancement resources",
        "Mentorship program participation",
        "Industry publications and journals",
        "Advocacy representation",
        "Professional liability consultation"
      ]
    },
    {
      title: "Veterinarian Professional", 
      price: "$189",
      period: "per year",
      description: "Specialized membership for veterinary professionals focused on animal health and cross-disciplinary collaboration.",
      icon: "ri-heart-pulse-line",
      color: "green",
      popular: false,
      features: [
        "Veterinary continuing education credits",
        "Animal health research access",
        "Cross-species treatment protocols",
        "Emergency care resources",
        "Pharmaceutical safety guidelines",
        "Client communication training",
        "Practice management tools",
        "Regulatory compliance updates",
        "Professional networking",
        "Telemedicine best practices"
      ]
    },
    {
      title: "Patient & Pet Owner",
      price: "$49",
      period: "per year", 
      description: "Community membership for individuals seeking advocacy, resources, and support for health and wellness needs.",
      icon: "ri-user-heart-line",
      color: "purple",
      popular: false,
      features: [
        "Health and wellness resources",
        "Educational webinars and workshops",
        "Community support networks",
        "Advocacy services and representation",
        "Medication safety information",
        "Pet health and care guides",
        "Access to health screening events",
        "Newsletter and updates",
        "Member discounts on services",
        "Emergency preparedness resources"
      ]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Choose Your Membership
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Select the membership that best fits your professional needs and career goals.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {membershipPlans.map((plan, index) => (
            <div 
              key={index} 
              className={`relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow p-8 ${
                plan.popular ? 'ring-2 ring-blue-500 transform lg:scale-105' : ''
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-medium">
                    Most Popular
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <div className={`w-16 h-16 bg-${plan.color}-100 rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${plan.icon} text-2xl text-${plan.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {plan.title}
                </h3>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-600 ml-2">{plan.period}</span>
                </div>
                <p className="text-gray-600">
                  {plan.description}
                </p>
              </div>
              
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-3 mt-0.5 flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                variant={plan.popular ? "primary" : "outline"} 
                className="w-full"
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
